<a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
  @if ( auth.user?.avatar | fileUrl : { height: 64, width: 64 } | async; as src)
  {
  <img [ngSrc]="src" height="26" width="26" />
  } @else {
  <un-icon class="top-icon" type="user" theme="outline"></un-icon>
  }
  <ng-template #icon
    ><un-icon class="top-icon" type="user" theme="outline"></un-icon
  ></ng-template>
  <un-icon class="t-tiny" type="down" theme="outline"></un-icon>
</a>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzMode="inline">
    @for (menu of menus; track menu) {
    <li nz-menu-item [routerLink]="menu.link">
      <a [routerLink]="menu.link">
        @if (menu.icon && menu.iconTheme) {
        <un-icon [type]="menu.icon" [theme]="menu.iconTheme"></un-icon>
        }
        {{ menu.text }}
      </a>
    </li>
    } @if (!auth.isLoggedIn) {
    <li nz-menu-item (click)="authModal.login()">
      <un-icon type="login" theme="outline"></un-icon>
      <span i18n="@@signIn">Sign In</span>
    </li>
    } @if (!auth.isLoggedIn) {
    <li nz-menu-item (click)="authModal.register()">
      <un-icon type="user-add" theme="outline"></un-icon>
      <span i18n="@@signUp">Sign Up</span>
    </li>
    } @if (auth.isLoggedIn) {
    <li nz-menu-item (click)="auth.logout()">
      <un-icon type="logout" theme="outline"></un-icon>
      <span i18n="@@logout">Logout</span>
    </li>
    }
  </ul>
</nz-dropdown-menu>
